











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ImageButton extends Vue {
  @Prop()
  imageSrc!: string;
  @Prop({ default: false })
  padding!: boolean;
  @Prop()
  maxWidth!: number;
  @Prop({ default: true })
  eager!: boolean;

  onClick(): void {
    this.$emit("click");
  }
}
